module.exports = __webpack_public_path__ + "static/media/logo.f4109435.svg";